<template>
  <div>
    <b-card>
      <div class="mt-1 mb-4">
        <b-button class="text-white" variant="warning" @click="openModalForm">
          Add Objective KPI
        </b-button>
      </div>
      <b-table
        ref="table"
        striped
        :items="fetchObjectiveKpi"
        :fields="fields"
      >
        <template #cell(no)="{ index }">
          {{ index + 1 }}
        </template>
        <template #cell(action)="{ item }">
          <div class="data">
            <b-link
              class="text-secondary mr-2"
              @click="openModalObjectivePerEmployee(item.id)"
            >
              <fa-icon icon="link"/>
            </b-link>
            <b-link
              class="text-secondary mx-2"
              @click="openModalViewObjectEmployee(item)"
            >
              <fa-icon icon="eye"/>
            </b-link>
            <b-link
              class="text-secondary mx-2"
              @click="openModalDelete(item)"
            >
              <fa-icon icon="trash"/>
            </b-link>
          </div>
        </template>
      </b-table>
    </b-card>
    <div>
      <modal-form-objective
        :employees="employees"
        @create="recieveDataObjective"
      />
    </div>
    <div>
      <modal-delete-objective
        :objectiveName="targetDeleteObjective.objective"
        @remove="deleteObjective"
      />
    </div>
    <div>
      <modal-form-objective-per-employee
        :employees="employees"
        @create="recieveDataObjectiveEmployee"
      />
    </div>
    <div>
      <modal-view-objective-employee
        :items="objectivePerEmployee"
        @remove="deleteEmployeeFromObjective"
      />
    </div>
  </div>
</template>

<script>
import api from '@/api'
import ModalFormObjective from './ModalFormObjective'
import ModalDeleteObjective from './ModalDeleteObjective'
import ModalFormObjectivePerEmployee from './ModalObjectivePerEmployee'
import ModalViewObjectiveEmployee from './ModalViewObjective'

export default {
  components: {
    ModalFormObjective,
    ModalDeleteObjective,
    ModalFormObjectivePerEmployee,
    ModalViewObjectiveEmployee
  },
  data() {
    return {
      objectiveKpi: [],
      fields: [
        { key: 'no', label: 'No', thClass: 'text-center', tdClass: 'text-center' },
        { key: 'objective', label: 'Objective KPI', thClass: 'text-center', tdClass: 'text-center' },
        { key: 'action', label: 'Action', thClass: 'text-center', tdClass: 'text-center' }
      ],
      targetDeleteObjective: {},
      employees: [],
      objectivePerEmployee: {
        idObjective: '',
        nameObjective: '',
        idEmployee: []
      },
      targetPostObjectiveEmployee: []
    }
  },
  methods: {
    async fetchObjectiveKpi() {
      try {
        const { data } = await api.kpi.getObjectiveKpi()
        this.objectiveKpi = data.data.map((item, i) => {
          return {
            objective: item.name,
            id: item.id,
            _rowVariant: i % 2 === 0 ? 'warning' : ''
          }
        })
      } catch (error) {
        console.log(error)
      }
      this.fetchEmployee()
      return this.objectiveKpi
    },
    async fetchEmployee() {
      try {
        const { data } = await api.employee.list({
          page: 1,
          pageSize: 100,
          Filters: 'Status==True',
          sorts: 'fullName'
        })
        this.employees = data.data.filter((item, index, self) =>
          self.findIndex(obj => obj.fullName === item.fullName) === index)
      } catch (error) {
        console.log(error)
      }
    },
    async createNewObjective(data) {
      try {
        await api.kpi.createObjective({
          name: data
        })
        this.$nextTick(() => {
          this.$bvToast.toast('Success create new objective', {
            headerClass: 'd-none',
            solid: true,
            variant: 'success'
          })
        })
        this.$refs.table.refresh()
      } catch (error) {
        console.log(error)
        this.$nextTick(() => {
          this.$bvToast.toast('Create new objective failed', {
            headerClass: 'd-none',
            solid: true,
            variant: 'danger'
          })
          this.$refs.table.refresh()
        })
      }
    },
    async createObjectiveEmployee() {
      try {
        const promises = this.targetPostObjectiveEmployee.map(async (item) => {
          await api.kpi.postObjectiveEmployee({
            objectiveId: this.objectivePerEmployee.idObjective,
            employeeId: item.employeeId
          })
          await new Promise(resolve => setTimeout(resolve, 1000))
        })
        await Promise.all(promises)
        this.$nextTick(() => {
          this.$bvToast.toast('Success create add objective to Employee', {
            headerClass: 'd-none',
            solid: true,
            variant: 'success'
          })
        })
        this.$refs.table.refresh()
      } catch (error) {
        console.log(error)
        this.$nextTick(() => {
          this.$bvToast.toast('Create objective to Employee failed', {
            headerClass: 'd-none',
            solid: true,
            variant: 'danger'
          })
          this.$refs.table.refresh()
        })
      }
      this.targetPostObjectiveEmployee = []
    },
    async deleteObjective() {
      try {
        await api.kpi.deleteObjective(this.targetDeleteObjective.id)
        this.$nextTick(() => {
          this.$bvToast.toast('Success delete objective', {
            headerClass: 'd-none',
            solid: true,
            variant: 'success'
          })
        })
        this.$refs.table.refresh()
      } catch (error) {
        console.log(error)
        this.$nextTick(() => {
          this.$bvToast.toast('Failed delete objective', {
            headerClass: 'd-none',
            solid: true,
            variant: 'danger'
          })
          this.$refs.table.refresh()
        })
      }
    },
    async getObjectiveEmployees(id) {
      try {
        const { data } = await api.kpi.getObjectiveEmployee()
        this.objectivePerEmployee.idEmployee = []
        data.data.forEach((item, i) => {
          if (item.objectiveId === id) {
            this.employees.forEach((index) => {
              if (index.id === item.employeeId) {
                this.objectivePerEmployee.idEmployee.push({
                  name: index.fullName,
                  employeeNo: index.employeeNo,
                  employeeId: index.id,
                  id: item.id,
                  _rowVariant: i % 2 === 0 ? 'warning' : ''
                })
              }
            })
          }
        })
      } catch (error) {
        console.log(error)
        this.objectivePerEmployee.idEmployee = []
      }
    },
    async deleteEmployeeFromObjective(id) {
      try {
        const { data } = await api.kpi.deleteObjectiveEmployee(id)
        this.$nextTick(() => {
          this.$bvToast.toast(data.messageEng, {
            headerClass: 'd-none',
            solid: true,
            variant: 'success'
          })
          this.$refs.table.refresh()
        })
      } catch (error) {
        console.log(error)
        this.$nextTick(() => {
          this.$bvToast.toast(error.messageEng, {
            headerClass: 'd-none',
            solid: true,
            variant: 'danger'
          })
          this.$refs.table.refresh()
        })
      }
    },
    openModalForm() {
      this.editMode = false
      this.$bvModal.show('modal-form-objective')
    },
    openModalDelete(item) {
      this.$bvModal.show('modal-delete-objective-kpi')
      this.targetDeleteObjective = { ...item }
    },
    openModalViewObjectEmployee(item) {
      this.objectivePerEmployee.nameObjective = item.objective
      this.objectivePerEmployee.idObjective = item.id
      this.getObjectiveEmployees(item.id)
      this.$bvModal.show('modal-view-objective-employee')
    },
    openModalObjectivePerEmployee(id) {
      this.objectivePerEmployee.idObjective = id
      this.$bvModal.show('modal-form-objective-employee')
    },
    recieveDataObjective(data) {
      this.createNewObjective(data)
      this.$refs.table.refresh()
    },
    recieveDataObjectiveEmployee(data) {
      this.employees.forEach(item => {
        data.forEach((index) => {
          if (item.fullName === index) {
            this.targetPostObjectiveEmployee.push({
              employeeId: item.id,
              name: item.fullName
            })
          }
        })
      })
      this.createObjectiveEmployee()
      this.$refs.table.refresh()
    }
  }
}
</script>
